import { render, staticRenderFns } from "./ActiveSessions.vue?vue&type=template&id=b2ff83ca&"
import script from "./ActiveSessions.vue?vue&type=script&lang=js&"
export * from "./ActiveSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports